import React, { useEffect, useState, useContext } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { loadStripe } from '@stripe/stripe-js';
import axios from 'axios';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { useTranslate } from '../config/translateContext';
import AuthContext from '../config/AuthContext';
import axiosInstance from '../config/axiosConfig';
const stripePromise = loadStripe('pk_live_51PSwQGP0Uqj7v8hTCMUmy3DxoIhgpUOzPjB2w51RzNr5TpPaPhpuV4usVJX39Vpe7kZFhjFxlHyuHPjB9oWyeFeb00XwKc6gaW');

const SubscriptionDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [subscription, setSubscription] = useState(null);
  const [mySub, setMySub] = useState(null);
  const { isTranslated, setIsTranslated } = useTranslate();
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);
  const { isAuthenticated } = useContext(AuthContext);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  useEffect(() => {
    if (!loading && !isAuthenticated) {
      navigate('/login');
    }
  }, [loading, isAuthenticated, navigate]);

  useEffect(() => {
    if (!isAuthenticated) return;
    
    console.log('Fetching subscription data...');
    const token = localStorage.getItem('access_token');
    axiosInstance.get(`/subscription/${id}/`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    })
    .then(response => {
      const { subscription, is_my_subscription } = response.data;
      setSubscription(subscription);
      setMySub(is_my_subscription);
      console.log('Subscription data:', response.data);
    })
    .catch(error => {
      console.error('Error fetching subscription:', error);
    });
  }, [id, isAuthenticated]);



  const [alertMessage, setAlertMessage] = useState(null); // Stan do przechowywania wiadomości alertu
  const [alertType, setAlertType] = useState('success'); // Typ alertu: 'success', 'danger', etc.






 const handleCheckout = async () => {
    const token = localStorage.getItem('access_token');

    try {
      const response = await axiosInstance.post(`/subscription/${id}/`, {
        action: 'update_subscription', // Nowa akcja
      }, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        }
      });

      if (response.status === 200) {
        // Wyświetlenie wiadomości w alercie Bootstrapowym
        setAlertMessage(response.data.message); // Wiadomość z backendu
        setAlertType('success');
        console.log(response.data);
      } else {
        console.error('Unexpected response:', response);
        setAlertMessage('Coś poszło nie tak / Etwas ist schief gelaufen.');
        setAlertType('danger');
      }
    } catch (error) {
      console.error('Error updating subscription:', error);
      setAlertMessage('Nie udało się zaktualizować subskrypcji / Aktualisierung des Abonnements fehlgeschlagen.');
      setAlertType('danger');
    }
  };





  const [successMessage, setSuccessMessage] = useState(null);
  const [errorMessage, setErrorMessage] = useState(null);

  const handleDeactivate = async () => {
    console.log('Deactivation function called');
    setLoading(true);
    setSuccessMessage(null);
    setErrorMessage(null);

    try {
      const token = localStorage.getItem('access_token');
      if (!token) {
        setErrorMessage('Użytkownik niezalogowany / Benutzer nicht angemeldet');
        setLoading(false);
        return;
      }

      console.log('Token:', token);

      const response = await axiosInstance.post(`/deactivate_subscription/`, null, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });

      console.log('Response:', response);

      if (response.status === 200) {
        setSuccessMessage('Subskrypcja została zdezaktywowana / Das Abonnement wurde deaktiviert.');
      } else {
        setErrorMessage('Dezaktywacja nie powiodła się / Deaktivierung fehlgeschlagen.');
      }
    } catch (error) {
      if (error.response) {
        console.error('Error response:', error.response);
        setErrorMessage(
          `Błąd dezaktywacji: ${error.response.data.error} / Deaktivierungsfehler: ${error.response.data.error}`
        );
      } else if (error.request) {
        console.error('Error request:', error.request);
        setErrorMessage('Brak odpowiedzi z serwera / Keine Antwort vom Server erhalten.');
      } else {
        console.error('Error message:', error.message);
        setErrorMessage(`Błąd dezaktywacji: ${error.message} / Deaktivierungsfehler: ${error.message}`);
      }
    } finally {
      setLoading(false);
    }
  };








useEffect(() => {
  console.log('mySub updated:', mySub);
  console.log('subscription updated:', subscription);
}, [mySub, subscription]);

  if (!isAuthenticated) {
    return <h1>Musisz być zalogowany</h1>;
  }

  if (!subscription) {
    return (
      <div className='w-100 d-flex justify-content-center h-100 ontop position-fixed t-0 cloude'>
        <img src='/img/logo.png' className='rotating-object align-self-center loader' alt="Loader" />
      </div>
    );
  }

  return (
    <div className='container vh10'>



          {/* Alert sukcesu */}
      {successMessage && (
        <div className="alert alert-success mt-3" role="alert">
          {successMessage}
        </div>
      )}
      {/* Alert błędu */}
      {errorMessage && (
        <div className="alert alert-danger mt-3" role="alert">
          {errorMessage}
        </div>
      )}



          {/* Alert Bootstrapowy */}
      {alertMessage && (
        <div className={`alert alert-${alertType} mt-3`} role="alert">
          {alertMessage}
        </div>
      )}
    <h1>{subscription.subscription_type.name }</h1>
        <div
      dangerouslySetInnerHTML={{
        __html: isTranslated ? subscription.description_de : subscription.description
      }}
    />

 {(!mySub || mySub.id !== subscription.id) ? (
      <button onClick={handleCheckout} className='btn btn-primary'>
        {isTranslated ? 'Abonnieren' : 'Subskrybuj'}
      </button>
    ) : (
      <Button variant="outline-danger" className='my-5' onClick={handleShow}>
        {isTranslated ? 'Deaktivieren' : 'Deaktywuj'}
      </Button>
    )}

      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
      {isTranslated ? 'Es tut uns leid!' : 'Przykro nam!'}
        </Modal.Header>
        <Modal.Body>
          <p>
    {isTranslated
      ? 'Sind Sie sicher, dass Sie Ihr Abonnement kündigen möchten? Sie verlieren den Zugriff auf alle Premium-Funktionen.'
      : 'Czy na pewno chcesz dezaktywować swoją subskrypcję? Stracisz dostęp do wszystkich funkcji premium.'}
  </p>

      <button onClick={handleDeactivate} disabled={loading} name='deactivation' className='btn btn-danger'>
  {loading ?
    (isTranslated ? 'Deaktivieren...' : 'Dezaktywowanie...') :
    (isTranslated ? 'Abonnement kündigen' : 'Dezaktywuj subskrypcję')
  }
</button>

          {error && <p>{error}</p>}
          {success && <p>Subscription deactivated successfully</p>}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
  {isTranslated ? 'Schließen' : 'Zamknij'}
</Button>

        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default SubscriptionDetail;
